export const translations = {
  cs: {
    heroTitle: "Technologie a inovace",
    heroSub: "které mění standardy",
    aboutNav: "O nás",
    partnersBtn: "Partneři",
    partnersTitle: "Naši partneři",
    noPartners: "Žádní partneři zatím nejsou k dispozici.",
    aboutTitle: "Tradice a inovace",
    aboutP1: "Systematicky vyhledáváme progresivní evropská řešení, která odborně posuzujeme a následně uvádíme na český trh. Naším cílem je implementace materiálů s prokazatelnou funkčností a dlouhodobou udržitelností.",
    aboutQuote: "Budoucnost energetiky a stavebnictví spočívá v propojení kvality a technické preciznosti.",
    activitiesLabel: "Naše činnosti",
    activitiesList: [
      "Zavádění moderních stavebních materiálů",
      "Podpora energeticky úsporných řešení",
      "Spolupráce se zahraničními výrobci",
      "Odborná podpora projektantů a investorů",
      "Legislativní a právní podpora projektů"
    ],
    contactLabel: "Kontakt",
    hqLabel: "Sídlo",
    contactSubLabel: "Spojení",
  },
  en: {
    heroTitle: "Technology and Innovation",
    heroSub: "setting new standards",
    aboutNav: "About Us",
    partnersBtn: "Partners",
    partnersTitle: "Our Partners",
    noPartners: "No partners are currently available.",
    aboutTitle: "Tradition and Innovation",
    aboutP1: "We systematically seek out progressive European solutions, which we professionally evaluate and subsequently introduce to the market. Our goal is the implementation of materials with proven functionality and long-term sustainability.",
    aboutQuote: "The future of energy and construction lies in the combination of quality and technical precision.",
    activitiesLabel: "Our Activities",
    activitiesList: [
      "Implementation of modern building materials",
      "Support for energy-efficient solutions",
      "Cooperation with international manufacturers",
      "Technical support for designers and investors",
      "Legislative and legal project support"
    ],
    contactLabel: "Contact",
    hqLabel: "Headquarters",
    contactSubLabel: "Communication",
  }
};